import { styled } from '@mui/material/styles'
import { InfoWindow } from '@vis.gl/react-google-maps'
import { Z_INDEX } from 'theme/zIndex'

export const StyledInfoWindow = styled(InfoWindow)(({ theme }) => ({
  '& .gm-style-iw-c': {
    padding: '0 !important',
    zIndex: Z_INDEX.MENU(theme) + 10,
    boxShadow: 'none !important',
    border: 'none !important',
  },
  '& .gm-style-iw-d': {
    overflow: 'hidden !important',
  },
  zIndex: Z_INDEX.MENU(theme) + 5,
}))
